export default __webpack_public_path__ + "static/media/Jessi.71e6de21.jpeg";